import React, { useEffect, useState } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { getters, actions } from "../model";

import { WithFormInstanceProvider } from "ui-kit/Form/View";
import { AppBar, Toolbar } from "@material-ui/core";

import { FORM_ID } from "../constants";
import { withRouter } from "react-router";

import { Div, HiResAvatarIcon } from "components/Base";

import EventSwitcher from "../../Shared/EventSwitcher";
// import PortalNotifications from "./PortalNotifications";
import ProfileDropdown from "./ProfileDropdown";

// import NotificationsIcon from "@material-ui/icons/Notifications";

import {
  getBackgroundColor,
  getLogoImageUrl,
  getLogoImageAltText
} from "Portal/NewPortal/PortalHome/selectors";
import * as PortalSelectors from "redux/modules/portal/selectors";
import { Default, Mobile } from "Portal/NewPortal/Shared/MediasQuery";
import Logo from "Portal/NewPortal/PortalHome/Components/Logo";
import MobileMenuFlyOver from "Portal/NewPortal/HeaderBar/MobileMenuFlyOver/View";
import { actions as mobileMenuFlyOverActions } from "Portal/NewPortal/HeaderBar/MobileMenuFlyOver/model";
import { noop } from "utils/General";
import { actions as homeActions } from "Portal/NewPortal/PortalHome/model";
import { SECTIONS_IDS } from "Portal/NewPortal/PortalHome/constants";

import { getUserPhoto } from "Portal/NewPortal/HeaderBar/selectors";

import { isEmptyOrNil } from "utils/General";

import BottomFlyOver from "Portal/NewPortal/Shared/BottomFlyOver";

import MobileActions from "Portal/NewPortal/HeaderBar/MobileActions";

import { getters as wrapperGetters } from "Portal/NewPortal/Wrapper/model";

import MobileSwitchEvents from "Portal/NewPortal/HeaderBar/MobileSwitchEvents";

const decorate = R.compose(
  withRouter,
  WithFormInstanceProvider(R.always(FORM_ID)),
  connect(
    state => ({
      loading: getters.loading(state),
      backgroundColor: getBackgroundColor(state),
      portal: PortalSelectors.portal(state),
      logoImageUrl: getLogoImageUrl(state),
      logoImageAltText: getLogoImageAltText(state),
      photoUrl: getUserPhoto(state),
      flyOverWidth: wrapperGetters.flyOverWidth(state)
    }),
    {
      init: actions.init,
      showMobileMenuFlyOver: mobileMenuFlyOverActions.openMobileMenuFlyOver,
      onCategoryClick: homeActions.setSelectedCategory
    }
  )
);

const Layout = ({
  init,
  location = null,
  backgroundColor,
  portal = {},
  logoImageUrl,
  logoImageAltText,
  showMobileMenuFlyOver,
  onCategoryClick = noop,
  photoUrl = null,
  flyOverWidth = null
}) => {
  useEffect(() => {
    init({ location });
  }, []);

  const avatarStyle = {
    width: "24px",
    height: "24px",
    borderRadius: "50%"
  };

  const [isActionsDialogOpen, setIsActionsDialogOpen] = useState(false);
  const [isSwitchEventsDialogOpen, setIsSwitchEventsDialogOpen] = useState(
    false
  );

  const handleClickOpenActions = () => setIsActionsDialogOpen(true);
  const handleClickOpenSwitchEvents = () => setIsSwitchEventsDialogOpen(true);

  const handleCloseActions = () => setIsActionsDialogOpen(false);
  const handleCloseSwitchEvents = () => setIsSwitchEventsDialogOpen(false);

  return (
    <>
      <Default>
        <div
          style={{
            backgroundColor: backgroundColor,
            padding: "12px 24px",
            width: "100%",
            height: "54px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            zIndex: 1,
            position: "fixed"
          }}
        >
          <Div style={{ width: "400px" }}>
            <EventSwitcher portal={portal} />
          </Div>
          <Div display="row.center.center" style={{ gap: 32, height: "100%" }}>
            {/*
            <Div display="row.center.center" style={{ gap: 16 }}>
              <PortalNotifications />
              <NotificationsIcon
                style={{
                  fontSize: "20px",
                  color: "#343434",
                  cursor: "pointer"
                }}
              />
            </Div>
            */}

            <ProfileDropdown />
          </Div>
        </div>
      </Default>
      <Mobile>
        <AppBar position="fixed" style={{ backgroundColor }}>
          <Toolbar
            style={{
              display: "flex",
              padding: "12px 24px",
              height: "54px",
              justifyContent: "space-between"
            }}
          >
            <Logo
              isOnNavBar
              logoImageUrl={logoImageUrl}
              logoImageAltText={logoImageAltText}
              style={{ cursor: "pointer" }}
              size="24px"
              onClick={() => {
                onCategoryClick({ category: SECTIONS_IDS.HOME });
              }}
            />

            <Div display="row.center.center" style={{ gap: 16 }}>
              <Div
                display="row.center.center"
                style={{ gap: 2, cursor: "pointer" }}
                onClick={handleClickOpenActions}
              >
                {!isEmptyOrNil(photoUrl) ? (
                  <img style={avatarStyle} src={photoUrl} alt={null} />
                ) : (
                  <HiResAvatarIcon style={avatarStyle} />
                )}
                <span
                  className="material-symbols-outlined"
                  style={{ color: "#343434", fontSize: "12px" }}
                >
                  keyboard_arrow_down
                </span>
              </Div>
              <Div
                display="row.center.center"
                style={{ gap: 16, cursor: "pointer" }}
                onClick={() => showMobileMenuFlyOver()}
              >
                <span
                  style={{ color: "#494949" }}
                  className="material-symbols-outlined"
                >
                  menu
                </span>
              </Div>
            </Div>
          </Toolbar>
        </AppBar>
        {flyOverWidth && (
          <MobileMenuFlyOver
            handleClickOpenSwitchEvents={handleClickOpenSwitchEvents}
          />
        )}
        <BottomFlyOver
          open={isActionsDialogOpen}
          handleClose={handleCloseActions}
        >
          <MobileActions handleClose={handleCloseActions} />
        </BottomFlyOver>
        <BottomFlyOver
          open={isSwitchEventsDialogOpen}
          handleClose={handleCloseSwitchEvents}
        >
          <MobileSwitchEvents handleClose={handleCloseSwitchEvents} />
        </BottomFlyOver>
      </Mobile>
    </>
  );
};

export default decorate(Layout);
